import React, { useState } from 'react';
import { connect } from 'react-redux';
import { FaTimes } from 'react-icons/fa';
import * as StyledModal from './modals.styles';
import { mapper } from './modalMapper';
import { closeModals } from '../../actions/modalActions';
import sleep from '../../helpers/sleep';
import useOnKeydown from '../../hooks/useOnKeydown/useOnKeydown';

const Modals = ({ modalReducer, dispatch }) => {
	const [closing, setIsClosing] = useState(false);
	const { active } = modalReducer;
	const Modal = mapper[active];

	const close = async () => {
		if(!Modal) return;
		setIsClosing(true);
		await sleep(250);
		dispatch(closeModals());
		setIsClosing(false);
	};

	useOnKeydown('Escape', close);

	if(!Modal) return null;

	return (
		<StyledModal.Wrapper closing={closing}>
			<StyledModal.Overlay onClick={close}></StyledModal.Overlay>
			<StyledModal.Content>
				<StyledModal.CloseButton onClick={close}>
					<FaTimes />
				</StyledModal.CloseButton>
				<Modal closeModal={close} dispatch={dispatch} />
			</StyledModal.Content>
		</StyledModal.Wrapper>
	);
};

const mapStateToProps = ({ modalReducer }) => {
	return {
		modalReducer
	};
};

export default connect(mapStateToProps)(Modals);
